import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import Seo from "@/components/Seo";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { api.get(`/public/blog/${slug}`).then(({ data }) => setPost(data)).catch(() => setPost(false)); }, [slug]);

  return (
    <div className="min-h-screen bg-panel-bg text-panel-text">
      {post && <Seo title={`${post.title} | smsonay.site Blog`} description={post.excerpt} />}
      <PublicHeader />
      <article className="mx-auto max-w-3xl px-4 sm:px-6 py-12">
        <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-panel-secondary hover:text-brand-500"><ArrowLeft size={16} /> Tüm yazılar</Link>
        {post === false && <p className="mt-10">Yazı bulunamadı.</p>}
        {post && (
          <>
            <h1 className="mt-6 font-head text-3xl sm:text-4xl font-extrabold tracking-tight">{post.title}</h1>
            <span className="text-xs text-panel-muted mt-2 block">{(post.created_at || "").slice(0, 10)}</span>
            {post.cover && <img src={post.cover} alt={post.title} className="mt-6 rounded-2xl w-full object-cover" />}
            <div className="mt-6 leading-relaxed text-panel-secondary [&_h2]:font-head [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-panel-text [&_h2]:mt-6 [&_h2]:mb-3 [&_h3]:font-head [&_h3]:text-xl [&_h3]:font-semibold [&_h3]:text-panel-text [&_h3]:mt-5 [&_h3]:mb-2 [&_p]:mt-3 [&_ul]:list-disc [&_ul]:pl-6 [&_li]:mt-1 [&_a]:text-brand-500 [&_strong]:text-panel-text [&_img]:rounded-xl [&_img]:my-4"
              dangerouslySetInnerHTML={{ __html: post.html }} />
          </>
        )}
      </article>
      <PublicFooter />
    </div>
  );
}
